exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrapper[data-v-540382eb]{background-color:hsla(0,0%,100%,.8)}", ""]);

// exports
